function debounce(fn, delay) {
    let timer = null;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}

class ClerkSearch extends HTMLElement {
    /** @type {HTMLElement} */
    collectionOutput;
    /** @type {HTMLElement} */
    productOutput;
    /** @type {HTMLElement} */
    querySuggestionOutput;
    /** @type {HTMLElement} */
    popularSearches;

    constructor() {
        super();

        /** @type {HTMLInputElement} */
        this.input = this.querySelector('input[name="q"]');

        this.productCounts = this.querySelectorAll('[data-product-count]');
        this.toggles = document.querySelectorAll('[data-toggle="clerk-search"]');

        this.collectionOutput = this.querySelector('[data-results="collection"]');
        this.collectionOutputContent = this.collectionOutput.innerHTML;
        this.productOutput = this.querySelector('[data-results="product"]');
        this.querySuggestionOutput = this.querySelector('[data-results="query"]');
        this.popularSearchesOutput = this.querySelector('[data-results="popular-searches"]');
        this.popularSearches = this.querySelector('[data-popular-searches]');
        this.input.addEventListener("input", debounce(this.onInput.bind(this), 280));
        this.addEventListeners();
        this.getPopularProducts();
    }

    open ()  {
        document.documentElement.classList.add('lock');
        this.classList.add('open')
        this.input.focus();
    }

    close() {
        document.documentElement.classList.remove('lock');
        this.classList.remove('open')
    }

    addEventListeners() {
        this.addEventListener('click', (e) => {
            if (e.target.tagName === this.tagName) {
                this.close();
            }
        })

        this.toggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                this.classList.contains('open') ? this.close() : this.open();
            });
        })
    }

    clearOutputs() {
        this.collectionOutput.innerHTML = '';
        this.productOutput.innerHTML = '';
        this.querySuggestionOutput.innerHTML = '';

        this.querySuggestionOutput.parentElement.hidden = true;
        this.popularSearches.hidden = false;

        this.productCounts.forEach(elem => elem.hidden = true);
    }

    getPopularProducts() {
        const config = {
            key: window.integrations.clerk.key,
            labels: [`Search Drawer - ${this.defaultEndpoint}`],
            attributes: ["handle"],
            limit: 10
        }

        this.collectionOutput.innerHTML = this.collectionOutputContent;
        this.popularSearchesOutput.innerHTML = '';

        Clerk('call', this.defaultEndpoint, config,
            async (response) => {
                const productResponses = await Promise.all(response.product_data.map((product) => this.cachedFetch(`${Shopify.routes.root}products/${product.handle}?view=clerk-item`, 'text')));
                this.productOutput.innerHTML = productResponses.filter(i => !i.includes('<head')).map((productItem) => {
                    return productItem.replaceAll('product-quick-buy----', `product-quick-buy-clerk-live-search--`);
                }).join('')
                Clerk("click", "*[data-clerk-product-id]");
            })

        Clerk('call', 'search/popular', {
                key: window.integrations.clerk.key,
                limit: 3
            },
            async (response) => {
                response.result.forEach((suggestion) => {

                    var button = document.createElement('div');
                    button.textContent = suggestion

                    button.addEventListener('click', () => {
                        this.input.value = suggestion;
                        this.input.dispatchEvent(new Event('input'));
                    });

                    this.popularSearchesOutput.appendChild(button);
                });
            })
    }

    async onInput() {
        if (this.input.value.length === 0) {
            this.clearOutputs();
            this.getPopularProducts();
            return;
        }

        const queryObj = {
            visitor: this.visitor,
            key: window.integrations.clerk.key,
            query: this.input.value,
            labels: ["Search Drawer"],
            no_design: true,
            searches: {
                products: {
                    index: "products",
                    attributes: ["handle"],
                    limit: 10
                },
                categories: {
                    index: "categories",
                    attributes: [
                        "url",
                        "name"
                    ],
                    limit: 6
                }
            }
        }

        const searchQuery = fetch(`//api.clerk.io/v3/search/omni?payload=${JSON.stringify(queryObj)}`).then(r => r.json());
        const suggestionQuery = fetch(`//api.clerk.io/v2/search/suggestions?key=${window.integrations.clerk.key}&query=${this.input.value}&limit=6`).then(r => r.json())

        const searchQueries = await Promise.all([searchQuery, suggestionQuery])

        const omniResponse = searchQueries[0];
        const suggestionsResponse = searchQueries[1];

        this.clearOutputs();

        if (omniResponse) {
            if (omniResponse.results.products.result.length > 0) {
                const productResponses = await Promise.all(omniResponse.results.products.result.map((product) => this.cachedFetch(`${Shopify.routes.root}products/${product.handle}?view=clerk-item`, 'text')));

                this.productOutput.innerHTML = productResponses.filter(i => !i.includes('<head')).map((productItem) => productItem).join('');
                this.productCounts.forEach(elem => {
                    elem.hidden = false;
                    elem.innerHTML = elem.dataset.content.replace('PRODUCT_COUNT', omniResponse.results.products.estimated_total_count);
                });
            }

            if (omniResponse.results.categories.result.length > 0) {
                this.collectionOutput.innerHTML = omniResponse.results.categories.result.map(item => `<a href="${item.url}">${item.name}</a>`).join('');
            }
        }

        if (suggestionsResponse) {
            const suggestions = suggestionsResponse.result.filter(suggestion => suggestion !== this.input.value.toLowerCase()).slice(0, 3);
            suggestions.forEach((suggestion) => {

                var button = document.createElement('div');
                button.textContent = suggestion

                button.addEventListener('click', () => {
                    this.input.value = suggestion;
                    this.input.dispatchEvent(new Event('input'));
                });

                this.querySuggestionOutput.appendChild(button);
            });

            this.querySuggestionOutput.parentElement.hidden = suggestions.length === 0;
            this.popularSearches.hidden = suggestions.length > 0;
        }

        Clerk("click", "*[data-clerk-product-id]");
    }

    get visitor() {
        return window.sessionStorage.getItem('visitor_id') || 'auto';
    }

    cachedFetch(url, type = 'json') {
        return new Promise(async (resolve) => {
            if (sessionStorage.getItem(`clerk-search-${url}`)) {
                resolve(type === 'json' ? JSON.parse(sessionStorage.getItem(`clerk-search-${url}`)) : sessionStorage.getItem(`clerk-search-${url}`));
            } else {
                const response = await fetch(url).then(r => {
                    if (type === 'json') {
                        return r.json();
                    } else {
                        return r.text()
                    }
                });

                if (type === "text") {
                    if (!response.includes('<head')) sessionStorage.setItem(`clerk-search-${url}`, response);
                } else sessionStorage.setItem(`clerk-search-${url}`, type === 'json' ? JSON.stringify(response.results.products) : response);
                resolve(type === 'json' ? response.results.products : response)
            }
        })
    }

    get defaultEndpoint () {
        return this.getAttribute('endpoint');
    }
}

if (!window.customElements.get("clerk-search")) {
    window.customElements.define("clerk-search", ClerkSearch);
}